<template>
  <v-card outlined class="block">
    <h3>{{ $t('hedgeOS.dashboard.curveDashboard.title') }} <span class="meta">{{ $t('hedgeOS.dashboard.curveDashboard.meta') }}</span></h3>
    <div class="chart-wrap" style="height: 240px;">
      <svg viewBox="0 0 600 240" preserveAspectRatio="none">
        <line class="grid-line" x1="0" y1="60" x2="600" y2="60"/>
        <line class="grid-line" x1="0" y1="120" x2="600" y2="120"/>
        <line class="grid-line" x1="0" y1="180" x2="600" y2="180"/>

        <!-- DOL forward curve -->
        <path fill="none" stroke="#ff4d1f" stroke-width="2" d="M0,160 L60,150 L120,140 L180,128 L240,118 L300,108 L360,96 L420,86 L480,78 L540,70 L600,62"/>
        <circle cx="0" cy="160" r="3" fill="#ff4d1f"/>
        <circle cx="600" cy="62" r="3" fill="#ff4d1f"/>

        <!-- DI1 curve -->
        <path fill="none" stroke="#7bc4a4" stroke-width="2" d="M0,100 L60,95 L120,92 L180,88 L240,86 L300,85 L360,86 L420,88 L480,92 L540,96 L600,100"/>

        <!-- FRC cupom cambial -->
        <path fill="none" stroke="#e8b64a" stroke-width="2" stroke-dasharray="4,3" d="M0,180 L60,175 L120,170 L180,166 L240,162 L300,158 L360,155 L420,152 L480,150 L540,148 L600,146"/>

        <!-- labels -->
        <text class="axis-label" x="0" y="232">SPOT</text>
        <text class="axis-label" x="140" y="232">3M</text>
        <text class="axis-label" x="290" y="232">6M</text>
        <text class="axis-label" x="440" y="232">9M</text>
        <text class="axis-label" x="575" y="232">12M</text>

        <text class="axis-label" x="540" y="58" fill="#ff4d1f">{{ $t('hedgeOS.dashboard.curveDashboard.dolFwd') }}</text>
        <text class="axis-label" x="540" y="96" fill="#7bc4a4">{{ $t('hedgeOS.dashboard.curveDashboard.di1') }}</text>
        <text class="axis-label" x="540" y="142" fill="#e8b64a">{{ $t('hedgeOS.dashboard.curveDashboard.frc') }}</text>
      </svg>
    </div>
    <div class="curve-summary">
      {{ $t('hedgeOS.dashboard.curveDashboard.hedgeCost') }} <span style="color:var(--paper);">2.84% a.a.</span><br>
      {{ $t('hedgeOS.dashboard.curveDashboard.impliedCarry') }} <span style="color:var(--cool);">8.46% a.a.</span><br>
      {{ $t('hedgeOS.dashboard.curveDashboard.curvature') }} <span style="color:var(--paper);">{{ $t('hedgeOS.dashboard.curveDashboard.contango') }}</span>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "CurveDashboard",
};
</script>

<style scoped>
.block {
  background: var(--ink);
  padding: 2rem;
}

.block h3 {
  font-family: 'Fraunces', serif;
  font-weight: 600;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  margin-bottom: 1.5rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid var(--line);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.block h3 .meta {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.65rem;
  color: var(--muted);
  font-weight: 400;
  letter-spacing: 0.15em;
  text-transform: uppercase;
}

.chart-wrap {
  position: relative;
  margin-top: 0.5rem;
}

.chart-wrap svg {
  width: 100%;
  height: 100%;
}

.axis-label {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  fill: var(--muted);
}

.grid-line {
  stroke: var(--grid);
  stroke-width: 1;
}

.curve-summary {
  margin-top: 1.5rem;
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.72rem;
  color: var(--dim);
  line-height: 1.7;
}
</style>
